import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { Response } from "types/response";
import Error from "types/error";
import { Acquisition } from "types/acquisition";
import { generatePath } from "react-router-dom";

export default function useGetThumbnail(id: string | undefined) {
  const request: Request = {
    url: generatePath(ENDPOINTS.acquisitions.thumbnail, { id }),
    config: {
      method: "GET",
    },
  };

  const requestConfig = {
    queryKey: [ENDPOINTS.acquisitions.thumbnail, id],
    queryFn: () => client(request),
    enabled: !!id,
  };

  const { data, ...rest } = useQuery<Response<string>, Error>(requestConfig);

  return { data, ...rest };
}
